"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcessingSpinner = void 0;
var processing_spinner_component_1 = require("./processing-spinner.component");
Object.defineProperty(exports, "ProcessingSpinner", { enumerable: true, get: function () { return processing_spinner_component_1.ProcessingSpinner; } });
